import { createSelector } from 'reselect';

export const getComponentState = state => state.brochureEditor;

export const getTemplateCode = createSelector(
    getComponentState,
    (state) => state.templateCode
);
export const getQuantity = createSelector(
    getComponentState,
    (state) => state.variables.quantity
);
export const getBrochure = createSelector(
    getComponentState,
    (state) => state.brochure
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getAddingToCart = createSelector(
    getComponentState,
    (state) => state.addingToCart
);
export const getNotes = createSelector(
    getComponentState,
    (state) => state.variables.notes
);
export const getIsFavorite = createSelector(
    getComponentState,
    (state) => state.isFavorite
);
export const getAddingFavorite = createSelector(
    getComponentState,
    (state) => state.addingFavorite
);
export const getCheckingFavorite = createSelector(
    getComponentState,
    (state) => state.checkingFavorite
);
export const getSavingWork = createSelector(
    getComponentState,
    (state) => state.savingWork
);
export const getAction = createSelector(
    getComponentState,
    (state) => state.action
);
export const getType = createSelector(
    getComponentState,
    (state) => state.variables.type
);
export const getClinicName = createSelector(
    getComponentState,
    (state) => state.variables.clinicName
);
export const getAddress = createSelector(
    getComponentState,
    (state) => state.variables.address
);
export const getCity = createSelector(
    getComponentState,
    (state) => state.variables.city
);
export const getZip = createSelector(
    getComponentState,
    (state) => state.variables.zip
);
export const getMain = createSelector(
    getComponentState,
    (state) => state.variables.main
);
export const getFax = createSelector(
    getComponentState,
    (state) => state.variables.fax
);